<template>
  <div class="row a-center" style="width: calc(100% - 1.0417vw);" v-if="tags.length>0">
    <div class="">
      <div class="row a-center">
        <div class="row a-center mt10" :class="index==0?'':'ml20'" v-for="(item,index) in tagShow" :key="index">
          <div class="h20 row" v-if="item.image">
            <img class="w-f h-per100 fit-contain" :src="getImageUrl(item.image ? item.image : '')" />
          </div>
          <div class="text-nowrap c-22B811 ft16" v-else>
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name:"goodsNameTag",
  props:{
    tags:{
      type:Array,
      default(){
        return [];
      },
    },
    // 标签展示个数
    len:{
      type:Number,
      default:0,
    },
    needTop:{
      type:Boolean,
      default:true,
    }
  },
  data(){
    return {
      tagShow:[],
    };
  },
  created() {
    if(this.tags.length>0){
      this.tagShow = this.tags.slice(0,this.len);
    }
  },
  methods:{

  },
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 750px) and (max-width: 1250px){
  .h20{height: 1.25vw;}
}
@media screen and (max-width: 750px){
  .h20{height: 1.5625vw;}
}
</style>